import {useMsal} from '@azure/msal-react';
import {PropsWithChildren, useEffect} from 'react';
import {InteractionStatus} from '@azure/msal-browser';

import {setTokenAndAuthorized} from 'core/stores/auth';
import {AZURE_SCOPES} from 'core/constants';
import {EnnablLogger} from 'utils/ennabl';

export const AzureAuthProviderInternal = ({children}: PropsWithChildren) => {
  const {instance, accounts, inProgress} = useMsal();
  const token = accounts[0]?.idToken;

  useEffect(() => {
    if (token) {
      EnnablLogger.log(['AzureAuthProviderInternal', 'Setting token from MSAL account'], {token});
      setTokenAndAuthorized(token);
    }
  }, [token]);

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }

    if (accounts.length === 0) {
      EnnablLogger.log(['AzureAuthProviderInternal', 'no Azure accounts found, redirecting to login']);
      instance.loginRedirect({scopes: AZURE_SCOPES});
      return;
    }

    const refreshToken = async () => {
      try {
        const response = await instance.acquireTokenSilent({
          account: accounts[0],
          scopes: AZURE_SCOPES,
        });

        EnnablLogger.log(['AzureAuthProviderInternal', 'successfully refreshed Azure token'], {response});

        if (response.idToken) {
          setTokenAndAuthorized(response.idToken);
        }
      } catch (error) {
        EnnablLogger.error(['AzureAuthProviderInternal', 'failed to refresh Azure token'], {error});
      }
    };

    const timerId = setInterval(refreshToken, 1000 * 60 * 10);

    return () => {
      clearInterval(timerId);
    };
  }, [accounts, instance, inProgress]);

  return children;
};
